module.exports = __webpack_public_path__ + "static/media/amazon-redshift.575394fb.svg";